import { Component, OnInit } from '@angular/core';
import { Editor, toHTML } from 'ngx-editor';
import { HumanFactorResponse } from 'src/app/models/cleaver_hr_form_model';
import { CleaverService } from 'src/app/services/cleaver.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-human-factor-texts',
  templateUrl: './human-factor-texts.component.html',
  styleUrls: ['./human-factor-texts.component.css']
})
export class HumanFactorTextsComponent implements OnInit {
  
  public humanFactor: HumanFactorResponse = {
    factor: '',
    description: '',
  }
  public editor:Editor;
  public html;
  public factors: HumanFactorResponse[] = [];

  constructor(
    private cleaverService: CleaverService
  ) { }

  ngOnInit(): void {
    this.cleaverService.getHumanFactors({}).subscribe((data: HumanFactorResponse[]) => {
      this.factors = data;
    });
    this.editor = new Editor();

  }

  onProfileChange() {
    setTimeout(() => {
      let selectedFactor = this.factors.find(f => f.factor == this.humanFactor.factor);
      if (selectedFactor) {
        this.humanFactor.description = selectedFactor.description;
        this.html = this.humanFactor.description;
      } else {
        this.humanFactor.description = '';
        this.html = '';

      }      
    }, 300)

  }

  saveHtml(){
    var html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }

    this.humanFactor.description = html;
    this.cleaverService.createOrUpdateHumanFactor(this.humanFactor).subscribe(
      resp=>{
        Swal.fire('Actualizado');
        location.reload();

      },
      err=>console.log(err)
    )
    
  }

}
